import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import useTranslation from '@hooks/i18n/useTranslation.tsx';
import { MyProfile } from '@app/pages/my-profile/MyProfile.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

const PageMyProfilePage = () => {
  const { tr } = useTranslation();
  return (
    <ResponsiveLayout title={tr(`myprofile.myProfile`, `My profile`)}>
      {/*
        // @ts-ignore*/}
      <Card>
        <MyProfile />
      </Card>
    </ResponsiveLayout>
  );
};
export default withAuthenticationRequired(PageMyProfilePage);
